export class Supplier {
    id: number;
    externalRef: string;
    name: string;
    status: string;
    lastModifiedDate: string;
    createdDate: string;
    deleted: string;
    logicalDeletionDate: string;
    address: {
        address_line1: string;
        address_line2: string;
        address_line3: string;
        city: string;
        country: string;
        zip_code: string;
    };
    contact:{
        email: string;
        firstName: string;
        lastName: string;
        tel: string;
    };
}